module.exports = __webpack_public_path__ + "static/media/code-gray-bg.ada20284.png";